import styled from "styled-components";

export const TextInfo = styled.span`
  letter-spacing: 0.00625em;
  font-size: 1.2rem;
  line-height: 1.5rem;
  box-sizing: border-box;
  outline: none;
  white-space: pre-wrap;
  word-wrap: break-word;
  padding: 10px 16px;
`;

export const TextContainer = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
